// Browser context — canon Phase 4. Coarse device class + referrer. No PII.
export function deviceType(): 'mobile' | 'tablet' | 'desktop' {
  const width = typeof window !== 'undefined' ? window.innerWidth : 1024;
  if (width < 768) return 'mobile';
  if (width < 1024) return 'tablet';
  return 'desktop';
}

export function referrer(): string | undefined {
  if (typeof document === 'undefined') return undefined;
  return document.referrer || undefined;
}
